import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'category',
	prefix: 'category',
	key: 'category_id',
	fields: {
		category_id: Model.SCHEMA_NUMBER,
		category_name: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				category_id: this.get_id(),
				category_name: this.rawData().category_name
			}
		}
	}
})
